/**
 * Letters key component. Represents the alphabetical key toggler in the virtual keyboard.
 */
import KeyLetters from '@components/atoms/container/keyLetters';
import VirtualKeyboardContext from '@shared/components/utils/context/virtualKeyboardContext';
import { selectMagicRemoteEnabled } from '@shared/store/slices/magicRemote.slice';
import { useAppSelector } from '@shared/store/hooks';
import { useContext, useState } from 'react';

/**
 * @param index - The index of the key.
 * @returns The letters key component.
 */
export default function LettersKey({ index }: { index: number[] }) {
  const enabled = useAppSelector(selectMagicRemoteEnabled);
  const { listIndex, listFocused, onClick } = useContext(
    VirtualKeyboardContext
  );
  const [hovered, setHovered] = useState(false);
  const focused = !enabled && listFocused && index.includes(listIndex);
  const letterButtons = 'ABC';
  return (
    <KeyLetters
      onClick={() => index.length && onClick(index[0])}
      onPointerEnter={() => setHovered(true)}
      onPointerLeave={() => setHovered(focused)}
      focused={hovered || focused}
    >
      {letterButtons}
    </KeyLetters>
  );
}
